import { DefaultService } from '@/services/DefaultService';

export default class MotivoAtendimentoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(motivoatendimentoagricola) {
        return this._http.post(`${this._env}/ven/motivoatendimento`, motivoatendimentoagricola, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(motivoatendimentoagricola) {
        return this._http.post(`${this._env}/ven/motivoatendimento/updatesituacao`, motivoatendimentoagricola, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/ven/motivoatendimento/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/ven/motivoatendimento/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/motivoatendimento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    changeSituacao(id, situacao) {
        return this._http.get(`${this._env}/ven/motivoatendimento/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}